import { footerNote } from "@/mocks/chigua";

const columns = [
  {
    title: '官方内容',
    links: [
      { label: '官方公告', href: '#announcements' },
      { label: '官方声明', href: '#statements' },
      { label: '消息动态', href: '#dynamics' },
      { label: '资讯看点', href: '#features' },
    ],
  },
  {
    title: '服务支持',
    links: [
      { label: '官方 App', href: '#channels' },
      { label: '在线客服', href: '#channels' },
      { label: '意见反馈', href: '#channels' },
      { label: '防骗指南', href: '#faq' },
    ],
  },
  {
    title: '更多入口',
    links: [
      { label: '商务合作', href: '#channels' },
      { label: '开发者平台', href: '#channels' },
      { label: '帮助中心', href: '#faq' },
      { label: '历史归档', href: '#announcements' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-5">
          <div className="col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
                <i className="ri-archive-2-fill"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                吃瓜<span className="text-secondary-300">官网</span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-200">
              权威发布吃瓜官网公告、声明与消息动态的官方信息中心,让每一次官方发声都不被错过。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {['ri-weibo-fill', 'ri-wechat-fill', 'ri-tiktok-fill', 'ri-youtube-fill'].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label="官方社交媒体"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-800 text-lg text-background-200 transition-colors hover:bg-secondary-500 hover:text-background-950"
                >
                  <i className={ic}></i>
                </a>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-bold text-background-50">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm text-background-200 transition-colors hover:text-secondary-300"
                    >
                      <i className="ri-arrow-right-s-line text-background-500"></i>
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 border-t border-background-800 pt-6">
          <p className="text-xs leading-relaxed text-background-300">{footerNote}</p>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 sm:flex-row">
          <div className="font-label text-xs text-background-300">
            © 2026 吃瓜官网 · 保留所有权利
          </div>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-background-300">
            <a href="#faq" className="transition-colors hover:text-background-50">用户协议</a>
            <a href="#faq" className="transition-colors hover:text-background-50">隐私政策</a>
            <a href="#channels" className="transition-colors hover:text-background-50">联系官方</a>
            <a href="#top" className="inline-flex items-center gap-1 rounded-full bg-background-800 px-3 py-1.5 text-background-100 transition-colors hover:bg-primary-600 hover:text-background-50">
              返回顶部
              <i className="ri-arrow-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}